'use strict';

const reinvested = 'Reinvested in the option',
      bankAccount = 'To your bank account';


module.exports = {
    reinvestedText: 'reinvested',
    bankAccountText: 'bankAccount',
    nominateText: 'nominate',
    paymentMethodText: 'paymentMethod',
    selectedBankAccountText: 'selectedBankAccount',
    incomeDistributionaccountNumberText: 'incomeDistributionaccountNumber',
    nominateAnotherAccount: 'Nominate another account',
    incomeDistribution: 'incomeDistribution',
    incomeDistributionHeader: 'Income distribution',
    IncomeDistributionRadioData: [{ id: 'reinvested', name: reinvested, isHidden: false }, { id: 'bankAccount', name: bankAccount, isHidden: false }]
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./constants/IncomeDistributionConstants.js